export const INVOICES = "INVOICES"
export const INVOICES_SUCCESS = "INVOICES_SUCCESS"
export const INVOICES_FAILED = "INVOICES_FAILED"
export const TAXLIST = "TAXLIST"
export const TAXLIST_SUCCESS = "TAXLIST_SUCCESS"
export const TAXLIST_FAILED = "TAXLIST_FAILED"
export const INVOICEID = "INVOICEID"
export const INVOICEID_SUCCESS = "INVOICEID_SUCCESS"
export const INVOICEID_FAILED = "INVOICEID_FAILED"
export const ADDINVOICE = "ADDINVOICE"
export const ADDINVOICE_SUCCESS = "ADDINVOICE_SUCCESS"
export const ADDINVOICE_FAILED = "ADDINVOICE_FAILED"
export const ADD_PURCHASE_INVOICE = "ADD_PURCHASE_INVOICE"
export const ADD_PURCHASE_INVOICE_SUCCESS = "ADD_PURCHASE_INVOICE_SUCCESS"
export const ADD_PURCHASE_INVOICE_FAILED = "ADD_PURCHASE_INVOICE_FAILED"
export const UPDATEINVOICE = "UPDATEINVOICE"
export const UPDATEINVOICE_SUCCESS = "UPDATEINVOICE_SUCCESS"
export const UPDATEINVOICE_FAILED = "UPDATEINVOICE_FAILED"
export const UPDATE_PURCHASE_INVOICE = "UPDATE_PURCHASE_INVOICE"
export const UPDATE_PURCHASE_INVOICESUCCESS = "UPDATE_PURCHASE_INVOICESUCCESS"
export const UPDATE_PURCHASE_INVOICE_FAILED = "UPDATE_PURCHASE_INVOICE_FAILED"
export const DELETEINVOICE = "DELETEINVOICE"
export const DELETEINVOICE_SUCCESS = "DELETEINVOICE_SUCCESS"
export const DELETEINVOICE_FAILED = "DELETEINVOICE_FAILED"
export const VIEWINVOICE = "VIEWINVOICE"
export const VIEWINVOICE_SUCCESS = "VIEWINVOICE_SUCCESS"
export const VIEWINVOICE_FAILED = "VIEWINVOICE_FAILED"
export const UPDATESTATUS = "UPDATESTATUS"
export const UPDATESTATUS_SUCCESS = "UPDATESTATUS_SUCCESS"
export const UPDATESTATUS_FAILED = "UPDATESTATUS_FAILED"
export const INVOICESLIST = "INVOICESLIST"
export const INVOICESLIST_SUCCESS = "INVOICESLIST_SUCCESS"
export const INVOICESLIST_FAILED = "INVOICESLIST_FAILED"
export const CURRENCY_LIST = "CURRENCY_LIST"
export const CURRENCY_LIST_SUCCESS = "CURRENCY_LIST_SUCCESS"
export const CURRENCY_LIST_FAILED = "CURRENCY_LIST_FAILED"
export const SYSTEM_SETTINGS = "SYSTEM_SETTINGS"
export const SYSTEM_SETTINGS_SUCCESS = "SYSTEM_SETTINGS_SUCCESS"
export const SYSTEM_SETTINGS_FAILED = "SYSTEM_SETTINGS_FAILED"
export const INVOICE_DEFAULT_TERMS = "INVOICE_DEFAULT_TERMS"
export const INVOICE_DEFAULT_TERMS_SUCCESS = "INVOICE_DEFAULT_TERMS_SUCCESS"
export const INVOICE_DEFAULT_TERMS_FAILED = "INVOICE_DEFAULT_TERMS_FAILED"
export const ADD_PURCHASEINVOICETOCSV = "ADD_PURCHASEINVOICETOCSV"
export const ADD_PURCHASEINVOICETOCSV_SUCCESS = "ADD_PURCHASEINVOICETOCSV_SUCCESS"
export const ADD_PURCHASEINVOICETOCSV_FAILURE = "ADD_PURCHASEINVOICETOCSV_FAILURE"
export const PURCHASE_INVOICES = "PURCHASE_INVOICES"
export const PURCHASE_INVOICES_SUCCESS = "PURCHASE_INVOICES_SUCCESS"
export const PURCHASE_INVOICES_FAILURE = "PURCHASE_INVOICES_FAILURE"
export const DELETEPURCHASEINVOICE = "DELETEPURCHASEINVOICE"
export const DELETEPURCHASEINVOICE_SUCCESS = "DELETEPURCHASEINVOICE_SUCCESS"
export const DELETEPURCHASEINVOICE_FAILED = "DELETEPURCHASEINVOICE_FAILED"